import { render, staticRenderFns } from "./ex-list2.vue?vue&type=template&id=0e8f0efc&scoped=true&"
import script from "./ex-list2.vue?vue&type=script&lang=js&"
export * from "./ex-list2.vue?vue&type=script&lang=js&"
import style0 from "./ex-list2.vue?vue&type=style&index=0&id=0e8f0efc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8f0efc",
  null
  
)

export default component.exports